import React from "react";
import TextField, { TextFieldProps } from "@material-ui/core/TextField";
import { IconButton, InputAdornment } from "@material-ui/core";
import { Visibility, VisibilityOff } from "@material-ui/icons";

type Props = {} & TextFieldProps;

export default function BaseTextField({ ...props }: Props) {
  const [showPassword, setShowPassword] = React.useState(false);

  if (props.type === "password") {
    return (
      <TextField
        {...props}
        type={showPassword ? "text" : "password"}
        InputLabelProps={{
          shrink: true,
          ...props.InputLabelProps,
        }}
        InputProps={{
          ...props.InputProps,
          endAdornment: (
            <InputAdornment position="end">
              <IconButton
                onClick={() => setShowPassword(!showPassword)}
                edge="end"
                aria-label="toggle password visibility"
              >
                {showPassword ? <VisibilityOff /> : <Visibility />}
              </IconButton>
            </InputAdornment>
          ),
        }}
      />
    );
  }
  return <TextField {...props} />;
}
